import React from 'react';
import { styled } from '@linaria/react';

function SouvlakiPieceStatic({ status, index, left }, ref) {
  const filter =
    status === 'fine'
      ? 'hue-rotate(0deg) saturate(0)'
      : 'hue-rotate(-43deg) saturate(5.5)';

  const wiggle =
    status === 'intersecting'
      ? index === 1
        ? 'left'
        : 'right'
      : undefined;

  return (
    <>
      <Layer
        alt=""
        data-wiggle={wiggle}
        src={`/images/interactive-guide-to-flexbox/souvlaki-${index}-back.png`}
        style={{
          left,
          filter,
          zIndex: 2,
          '--animation-duration': index === 1 ? '220ms' : '200ms',
        }}
      />
      <Layer
        ref={ref}
        alt=""
        data-wiggle={wiggle}
        src={`/images/interactive-guide-to-flexbox/souvlaki-${index}-front.png`}
        style={{
          left,
          filter,
          zIndex: index === 1 ? 101 : 99,
          '--animation-duration': index === 1 ? '220ms' : '200ms',
        }}
      />
    </>
  );
}

const Layer = styled.img`
  position: absolute;
  top: 0;
  height: 100%;

  &[data-wiggle='left'] {
    animation: wiggleLeft var(--animation-duration);

    @keyframes wiggleLeft {
      0% {
        transform: rotate(0deg);
      }
      20% {
        transform: rotate(10deg);
      }
      40% {
        transform: rotate(-10deg);
      }
      60% {
        transform: rotate(10deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
  }

  &[data-wiggle='right'] {
    animation: wiggleRight var(--animation-duration);

    @keyframes wiggleRight {
      0% {
        transform: rotate(0deg);
      }
      30% {
        transform: rotate(-5deg);
      }
      50% {
        transform: rotate(5deg);
      }
      80% {
        transform: rotate(-5deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
  }
`;

export default React.forwardRef(SouvlakiPieceStatic);
